<template>
  <v-container fluid grid-list-xl page>
    <v-layout row wrap>
      <v-flex xs12 sm8 md12>
        <section-header v-text="page.headline"></section-header>
        <div class="subheading justify" v-html="page.description"></div>
        <div class="my-5"></div>
      </v-flex>
    </v-layout>
    <!-- Your contet -->

    <div class="display-2 grey--text text--darken-1">
      Prepara y firma documentos
    </div>
    <div class="title grey--text text--darken-1">
      desde cualquier dispositivo, sin necesidad de instalar aplicaciones
    </div>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md6 lg3 offset-2>
                <v-card flat tile>
                  <v-img
                    justify-center
                    src="/static/send.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">ENVIA</h3>
                      <div>
                        Envia documentos para que sean firmados, desde tu
                        navegador tanto móvil como de escritorio, sin tener que
                        instalar ninguna aplicación.
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    src="/static/digital-signature.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">FIRMA</h3>
                      <div>
                        La persona o personas que tienen que firmar recibirán un
                        eemail para acceder al documento y firmarlo. También
                        podrá hacerlo desde la aplicación web d e Securyty si
                        tiene una cuenta creada.
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    s
                    src="/static/admin.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">GESTIONA</h3>
                      <div>
                        Monitoriza el estado de tus peticiones de firma desde el
                        panel de control de Securyty, revisa firmas pasadas y
                        accede y organiza los documentos firmados.
                      </div>
                    </div>
                  </v-card-title>

                  <!-- <v-card-actions>
                    <v-btn flat color="orange">Share</v-btn>
                    <v-btn flat color="orange">Learn More</v-btn>
                  </v-card-actions> -->
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-spacer></v-spacer>
 

    <v-layout height="100">
      <v-card height="100" flat color="grey"> </v-card>
    </v-layout>

    <div class="display-2 black--text text--darken-3 justify-center">
      Firmas sencillas y legales
    </div>
    <div class="title black--text text--darken-1">
      desde cualquier dispositivo
    </div>

    <v-layout>
      <v-flex>
        <v-card class="justify-center">
          <v-container fluid grid-list-md>
            <v-layout row wrap class="justify-center">
              <v-flex xs12 md6 lg3 offset-2>
                <v-card flat tile>
                  <v-img
                    justify-center
                    src="/static/send.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title>
                    <div>
                      <h3 class="headline mb-0">Sin aplicaciones</h3>
                      <div>
                        Tus clientes y empleados pueden firmar documentos en
                        menos de 30 segundos de forrma rápida e intuitiva.
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-flex>

              <!-- --------- -->

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    src="/static/digital-signature.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Desde cualquier dispositivo</h3>
                      <div>
                        La firma se puede realizar desde cualquier tipo de
                        dispositivo , el único requisito es tener un navegador y
                        acceso a Internet.
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 md6 lg3>
                <v-card flat tile>
                  <v-img
                    s
                    src="/static/admin.png"
                    width="100"
                    aspect-ratio="1"
                  ></v-img>

                  <v-card-title primary-title xs12 sm3>
                    <div>
                      <h3 class="headline mb-0">Con validez legal</h3>
                      <div>
                        Las firmas electrónicas de Securyty cumplen los
                        requisitos legales en la Unión Europea y EEUU.
                      </div>
                    </div>
                  </v-card-title>

                  <v-card-actions> </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="isCreateSign" persistent max-width="500px">
      <v-card>
        <v-toolbar color="orange" dark>
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
          <v-toolbar-title>Inicia una firma</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip right>
            <v-icon slot="activator" color="white" dark>help_outline</v-icon>
            <span
              ><b
                >Firma Electrónica (OTP) : <br /><br />- Revisa y aceepta un
                documento y fírmalo usando una One Time Password (OTP)<br /><br />
                Firma Manuscrita: <br /><br />- Firma electrónicamneete usando
                tu firma manuscrita</b
              >
            </span>
          </v-tooltip>
        </v-toolbar>
        <create-sign-page
          :scroll-top="scrollTop"
          signature-type="signature"
        ></create-sign-page>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            round
            color="red darken-4"
            dark
            bold
            outline
            @click.native="closeSignaturePage"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoginNeeded" max-width="300px">
      <v-card>
        <v-toolbar color="orange" dark>
          <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
          <v-toolbar-title>Acesso requerido</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- <v-tooltip right>
            <v-icon
                slot="activator"
                color="white"
                dark
              >help_outline</v-icon>

          </v-tooltip> -->
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap></v-layout>
            <span
              >Por favor, accede a tu cuenta o registrate antes de iniciar la
              prueba
            </span>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="isLoginNeeded = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CreateSignPage from "./CreateSignPage";

export default {
  components: {
    CreateSignPage
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      isLoginNeeded: false,
      isCreateSign: false,
      page: {
        title: "Firma Electrónica",
        headline: "Firma Electrónica",
        description: `Envía documentos para su firma`
      },
      breadcrumbs: [
        {
          text: "Src",
          disabled: false
        },
        {
          text: "Views",
          disabled: false
        },
        {
          text: "Blank",
          disabled: false
        }
      ],
      scrollTop: 0
    };
  },
  methods: {
    createSignature() {
      //this.$router.push("CreateSignPage")
      var current = this.$store.getters.userData;
      if (current == null || current.userEmail == null) {
        this.isLoginNeeded = true;
        this.$ga.event({
          eventCategory: "Loggin needed simple signature", // str
          eventAction: "click", // str
          eventLabel: "TryButton", // str
          eventValue: 0 // int
        });
        return;
      }
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      document.getElementsByTagName("body")[0].className = "noscroll";
      this.isCreateSign = true;
    },
    closeSignaturePage() {
      document.body.removeAttribute("class", "noscroll");
      window.scrollTo(0, this.scrollTop);
      this.isCreateSign = false;
    }
  }
};
</script>
